import React from 'react';

// -> {} | {error: true, variant: 'outline', helperText: str}
//do not force this: instead backend will need to coerce to str
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function validateEdgeSchemaTypeMatch(_ref) {
  var files = _ref.files,
    visualizationBindings = _ref.visualizationBindings;
  var _visualizationBinding = visualizationBindings.shaper.simple,
    enabled = _visualizationBinding.enabled,
    edges = _visualizationBinding.edges,
    nodes = _visualizationBinding.nodes;
  var fileIndex = edges.fileIndex,
    tableIndex = edges.tableIndex,
    src = edges.src,
    dst = edges.dst;
  if (!files || !files.length || fileIndex === null || tableIndex === null) {
    return {};
  }
  var fileObj = files[fileIndex];
  if (!fileObj) {
    console.error('Invalid file lookup', {
      fileIndex: fileIndex,
      files: files
    });
    return {};
  }
  var tableObj = fileObj.fileStats.tables_schemas[tableIndex];
  if (!tableObj) {
    console.error('Invalid table lookup', {
      tableIndex: tableIndex,
      files: files
    });
    return {};
  }
  if (src === null || dst === null) {
    return {};
  }
  if (tableObj.dtypes[src] != tableObj.dtypes[dst]) {
    return {
      error: true,
      variant: 'outline',
      helperText: "Column type mismatch: [".concat(src, "]'s type [").concat(tableObj.dtypes[src], "] conflicts with [").concat(dst, "]'s type [").concat(tableObj.dtypes[dst], "]")
    };
  }
  return {};
}

// -> {} | {error: true, variant: 'outline', helperText: str}
//do not force this: instead backend will need to coerce to str
export function validateNodeSchemaTypeMatch(_ref2) {
  var files = _ref2.files,
    visualizationBindings = _ref2.visualizationBindings;
  var _visualizationBinding2 = visualizationBindings.shaper.simple,
    enabled = _visualizationBinding2.enabled,
    edges = _visualizationBinding2.edges,
    nodes = _visualizationBinding2.nodes;
  var fileIndex = edges.fileIndex,
    tableIndex = edges.tableIndex,
    src = edges.src,
    dst = edges.dst;
  if (!files || !files.length || fileIndex === null || tableIndex === null || src === null && dst === null) {
    return {};
  }
  var fileObj = files[fileIndex];
  if (!fileObj) {
    console.error('Invalid file lookup', {
      fileIndex: fileIndex,
      files: files
    });
    return {};
  }
  var tableObj = fileObj.fileStats.tables_schemas[tableIndex];
  if (!tableObj) {
    console.error('Invalid table lookup', {
      tableIndex: tableIndex,
      files: files
    });
    return {};
  }
  var edgeType = tableObj.dtypes[src] || tableObj.dtypes[dst];
  var edgeTypeField = tableObj.dtypes[src] ? src : dst;
  if (!edgeType) {
    return {};
  }
  var nodeFileIndex = nodes.fileIndex,
    nodeTableIndex = nodes.tableIndex,
    node = nodes.node;
  if (nodeFileIndex === null || nodeTableIndex === null || node === null) {
    return {};
  }
  var nodeFileObj = files[nodeFileIndex];
  if (!nodeFileObj) {
    console.error('Invalid file lookup', {
      nodeFileIndex: nodeFileIndex,
      files: files
    });
    return {};
  }
  var nodeTableObj = nodeFileObj.fileStats.tables_schemas[nodeTableIndex];
  if (!nodeTableObj) {
    console.error('Invalid table lookup', {
      nodeTableIndex: nodeTableIndex,
      files: files
    });
    return {};
  }
  var nodeType = nodeTableObj.dtypes[node];
  if (!nodeType) {
    return {};
  }
  if (nodeType != edgeType) {
    return {
      error: true,
      variant: 'outline',
      helperText: "Column type mismatch: Node ID column [".concat(node, "]'s type [").concat(nodeType, "] conflicts with Edge src/dst ID column [").concat(edgeTypeField, "]'s type [").concat(edgeType, "]")
    };
  }
  return {};
}
export function bindingsReady(_ref3) {
  var files = _ref3.files,
    visualizationBindings = _ref3.visualizationBindings;
  var hasEdges = visualizationBindings.shaper.simple.edges.enabled && (visualizationBindings.shaper.simple.hyperedges || visualizationBindings.shaper.simple.edges.src !== null && visualizationBindings.shaper.simple.edges.src !== undefined && visualizationBindings.shaper.simple.edges.dst !== null && visualizationBindings.shaper.simple.edges.dst !== undefined) && visualizationBindings.shaper.simple.edges.fileIndex !== null && visualizationBindings.shaper.simple.edges.fileIndex !== undefined && visualizationBindings.shaper.simple.edges.tableIndex !== null && visualizationBindings.shaper.simple.edges.tableIndex !== undefined;

  //const validEdges = !validateEdgeSchemaTypeMatch({files, visualizationBindings}).error;

  var hasNodes = visualizationBindings.shaper.simple.nodes.enabled && visualizationBindings.shaper.simple.nodes.node !== null && visualizationBindings.shaper.simple.nodes.node !== undefined && visualizationBindings.shaper.simple.nodes.fileIndex !== null && visualizationBindings.shaper.simple.nodes.fileIndex !== undefined && visualizationBindings.shaper.simple.nodes.tableIndex !== null && visualizationBindings.shaper.simple.nodes.tableIndex !== undefined;

  //const validNodes = !validateNodeSchemaTypeMatch({files, visualizationBindings}).error;

  //const isReady = hasEdges && validEdges && validNodes;
  var isReady = hasEdges;
  return {
    hasNodes: hasNodes,
    hasEdges: hasEdges,
    //validEdges,
    //validNodes,
    isReady: isReady,
    message: isReady ? null : !hasEdges ? /*#__PURE__*/_jsxs("span", {
      children: ["Add edges file and ensure edge src/dst bindings set with matching column types. Optionally add a nodes file and ensure its node id column's type corresponds with the edge/src dst column type. To show nodes without any edges, create and upload text file ", /*#__PURE__*/_jsx("b", {
        children: "edges-stub.csv"
      }), " containing the one line ", /*#__PURE__*/_jsx("code", {
        children: "src,dst"
      }), ", and use empty columns ", /*#__PURE__*/_jsx("code", {
        children: "src"
      }), ", ", /*#__PURE__*/_jsx("code", {
        children: "dst"
      }), " for the bindings."]
    }) : /*#__PURE__*/_jsx("span", {
      children: "Unknown fix"
    })
  };
}